import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Simple hash function for generating stable keys from content
 * Uses djb2 hash algorithm
 *
 * @param str - String to hash
 * @returns Numeric hash value
 */
export function hashString(str: string): number {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash = hash & hash; // Convert to 32bit integer
	}
	return Math.abs(hash);
}

/**
 * Convert a string to Title Case
 * Lowercases the entire string first, then capitalizes the first letter of each word.
 * Handles ALL CAPS input correctly (e.g. "KITCHEN RENO" → "Kitchen Reno").
 *
 * @param str - String to convert
 * @returns Title Case string
 */
export function toTitleCase(str: string): string {
	return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Convert a string to a URL-friendly slug
 * - Converts to lowercase
 * - Removes special characters
 * - Replaces spaces with hyphens
 * - Removes consecutive hyphens
 *
 * @param str - String to slugify
 * @returns URL-friendly slug
 */
export function slugify(str: string): string {
	return str
		.toLowerCase()
		.trim()
		.replace(/[^\w\s-]/g, "") // Remove special characters
		.replace(/[\s_-]+/g, "-") // Replace spaces, underscores, and hyphens with single hyphen
		.replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
}
